/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("RowInfoController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class RowInfoController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class RowInfoController extends cls.ControllerBase /** @lends classes.RowInfoController.prototype */ {
    static __name = "RowInfoController";

    _initBehaviors() {
      super._initBehaviors();

      // vm behaviors
      this._addBehavior(cls.RowSelectedVMBehavior);
      // ui behaviors
    }
  }

  cls.RowInfoController = RowInfoController;
  cls.ControllerFactory.register("RowInfo", cls.RowInfoController);
});
